import { render } from "./Setting.vue?vue&type=template&id=5f60c45e&scoped=true"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"

import "./Setting.vue?vue&type=style&index=0&id=5f60c45e&lang=scss&scoped=true"

import exportComponent from "/Users/admin/Documents/Works/fast_energy_task_manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f60c45e"]])

export default __exports__